import { Routes } from '@angular/router';
import { HomepageComponent } from './homepage/homepage.component';
import { AboutComponent } from './about/about.component';

export const routes: Routes = [
  {
    path: '',
    component: HomepageComponent,
    data: {
      title: "Joaquin 'Highnet' Telleria | Full-Stack Developer & Game Dev",
      description:
        'Portfolio of Joaquin Telleria — full-stack developer shipping DeFi apps, civic platforms, a provably-fair slot engine, and indie games on Steam.',
    },
  },
  {
    path: 'about',
    component: AboutComponent,
    data: {
      title: "About | Joaquin 'Highnet' Telleria",
      description:
        "About Joaquin 'Highnet' Telleria — full-stack developer with a background in Human-Centered Computing, based in Vienna, Austria.",
    },
  },
];
